
import request from '@/utils/request'
import URL from './urlTranslator'

// 获取auth地址配置
export function getAuthUrl() {
  return request({
    url: URL.sys.getAuthUrl,
    headers: {
      'tenantId': '99' // 匿名访问接口，设置一个默认的租户ID，否则调不通
    },
    method: 'get'
  })
}

// 获取auth地址配置
export function getUsAuthUrl() {
  return request({
    url: URL.sys.getUsAuthUrl,
    headers: {
      'tenantId': '99' // 匿名访问接口，设置一个默认的租户ID，否则调不通
    },
    method: 'get'
  })
}

export function getAuthUserInfo() {
  return request({
    url: URL.sys.authUserInfo,
    method: 'get'
  })
}

export function getUserPrivilege(params) {
  return request({
    url: URL.sys.getUserPrivilege,
    method: 'get',
    params: params
  })
}

export function getUserPrivileges() {
  return request({
    url: URL.sys.getUserPrivileges,
    method: 'get'
  })
}

export function getUserAllOfficePrivilege() {
  return request({
    url: URL.sys.getUserAllOfficePrivilege,
    method: 'get'
  })
}

export function wechatUntied() {
  return request({
    url: URL.sys.wechatUntied,
    method: 'get'
  })
}
export function queryWechatUser() {
  return request({
    url: URL.sys.queryWechatUser,
    method: 'get'
  })
}

// 根据用户查询他人的授权
export function getDelegationsByDelegateeId(userId) {
  return request({
    url: URL.sys.getDelegationsByDelegateeId,
    method: 'get',
    params: { userId }
  })
}
export function delegate(delegatorId) {
  return request({
    url: URL.sys.delegate,
    method: 'get',
    params: { delegatorId }
  })
}
export function logoutDelegate(delegationUuid) {
  return request({
    url: URL.sys.logoutDelegate,
    method: 'get',
    params: { delegationUuid }
  })
}
// 获取所有租户信息
export function getAllTenant() {
  return request({
    url: URL.sys.tenant,
    method: 'get'
  })
}

// 获取通告板个人信息权限列表
export function getUserAuthBySessionId() {
  return request({
    url: URL.sys.getUserAuthBySessionId,
    method: 'get'
  })
}

// 更新通告板个人信息权限
export function updateUserAuth(data) {
  return request({
    url: URL.sys.updateUserAuth,
    method: 'put',
    data
  })
}

// 查询授权用户信息
export function searchSession(data) {
  return request({
    url: URL.sys.searchSession,
    method: 'post',
    data
  })
}

// 保存授权信息
export function saveDelegate(data) {
  return request({
    url: URL.sys.saveDelegate,
    method: 'post',
    data
  })
}

// 根据用户查询自己的授权
export function getDelegationsByUserId(data) {
  return request({
    url: URL.sys.getDelegationsByUserId,
    method: 'post',
    data
  })
}

// 撤销授权
export function cancelDelegation(data) {
  return request({
    url: URL.sys.cancelDelegation,
    method: 'post',
    data
  })
}
